import { ModuleConfig, ModuleFields } from "~/Utils/drilldownData";

export const getspotlightSmallCardsDrillDownData: { [key in ModuleConfig]: ModuleFields[] } = {
  smallcards: [
    {
        fieldName: "Order Sequence",
        fieldValue: "field_cards_sequence",
        className: "col-span-6",
        type: "text",
        name: "field_cards_sequence",
        formType: "input",
        label: "Order Sequence",
        placeholder: "Enter Order Sequence",
        validation: { required: "Order Sequence is required" },
    },
    {
      fieldName: "Image",
      fieldValue: "field_cards_image",
      className: "col-span-6",
      type: "image",
      name: "field_cards_image",
      formType: "file",
      usedFileType: 'image/*',
      label: "Image",
      placeholder: "Select Image",
      validation: { required: "Image is required" },
    },
    {
      fieldName: "Title (EN)",
      fieldValue: "title",
      className: "col-span-6",
      type: "text",
      name: "title",
      formType: "input",
      label: "Title (EN)",
      placeholder: "Enter Title (EN)",
      validation: { required: " Title (EN) is required" },
    },
    {
        fieldName: "Title (MS)",
        fieldValue: "field_cards_title_ms",
        className: "col-span-6",
        type: "text",
        name: "field_cards_title_ms",
        formType: "input",
        label: "Title (MS)",
        placeholder: " Title (MS)",
        // validation: { required: " Title is required" },
      },  {
        fieldName: "Title (ZH)",
        fieldValue: "field_cards_title_zh",
        className: "col-span-6",
        type: "text",
        name: "field_cards_title_zh",
        formType: "input",
        label: "Title (ZH)",
        placeholder: "Enter Title (ZH)",
        // validation: { required: " Title is required" },
      },
    {
        fieldName: "Description (EN)",
        fieldValue: "field_cards_desc_en",
        className: "col-span-6",
        type: "text",
        name: "field_cards_desc_en",
        formType: "textarea",
        label: "Description (EN)",
        placeholder: "Enter Description (EN)",
        validation: { required: "Description (EN) is required" },
      },
      {
        fieldName: "Description (MS)",
        fieldValue: "field_cards_desc_ms",
        className: "col-span-6",
        type: "text",
        name: "field_cards_desc_ms",
        formType: "textarea",
        label: "Description (MS)",
        placeholder: "Enter Description (MS)",
        // validation: { required: "Description (MS) is required" },
      },
      {
        fieldName: "Description (ZH)",
        fieldValue: "field_cards_desc_zh",
        className: "col-span-6",
        type: "text",
        name: "field_cards_desc_zh",
        formType: "textarea",
        label: "Description (ZH)",
        placeholder: "Enter Description (ZH)",
        // validation: { required: "Description (ZH) is required" },
      },
    {
      fieldName: "Cards url",
      fieldValue: "field_cards_url_en",
      className: "col-span-6",
      type: "text",
      name: "field_cards_url_en",
      formType: "input",
      label: "Cards url",
      placeholder: "Enter Cards url",
      validation: { required: "Cards Url is required", validate: (value: string) => {
  const trimmed = value.trim();
  if (!trimmed.startsWith("/")) return "Please use an in-app page link, such as /example";
  if (["http://", "https://", "www."].some(p => trimmed.includes(p))) {
    return "Looks like an external link. Please use an in-app page link, such as /example";
  }
  return true;
}, },
    },
    // {
    //   fieldName: "Cards url (MS)",
    //   fieldValue: "field_cards_url_ms",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_cards_url_ms",
    //   formType: "input",
    //   label: "Cards url (MS)",
    //   placeholder: "Enter Cards url (EN)",
    //   // validation: { required: "Cards Url (EN) is required" },
    // },
    // {
    //   fieldName: "Cards url (ZH)",
    //   fieldValue: "field_cards_url_zh",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_cards_url_zh",
    //   formType: "input",
    //   label: "Cards url (ZH)",
    //   placeholder: "Enter Cards url (ZH)",
    //   // validation: { required: "Cards url (ZH) is required" },
    // },
    {
      fieldName: "Published",
      fieldValue: "published",
      className: "col-span-12",
      type: "checkbox",
      name: "published",
      formType: "checkbox",
      label: "Published",
      placeholder: "Enter Published",
      // validation: { required: "Publish is required" },
    }
  ],
};
